import React from "react"
import FieldDropdown from "../../../generic/dropdown/dropdown"
import FieldConfig from "../../../proto/field-config"
import {GROUP_NUMBER} from "../../../../gd/const/fields/field2-groups"
import {FieldFilterType} from "../../../proto/types";

const debug = false
// const debug = "FieldCompanyUserRequiredReportTime"

export default class FieldCompanyUserRequiredReportTime extends FieldDropdown {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Required report time"
        this.typeGroup          = GROUP_NUMBER
        this.typeDescription    = "Company user required report time"
        this.filterType         = FieldFilterType.NUMBER
        this.icon               = 'i5-my-time'

        this.noValueOption      = false
        this.showMenuMore       = false

        this.options = _.map(gd.const.companyUser.requiredReportTime, (val:any,key:string) => ({
            label: key !== '0' ? val : 'Not required',
            value: parseInt(key)
        }))

        debug && console.log(debug, 'constructor', this.options, gd.const.companyUser.requiredReportTime)
    }
}
